var exports = {
  "k": "x93eb46d8--ff162e--container",
};

module.exports = exports;
